import { useWidget } from '../../../providers/widget'
import { DescriptionWidgetConfig } from '../config'
import { useFetchDescription } from '../data'
import { findObjectByLocale, useLocaleDetection } from '../../../hooks/locale'
import DescriptionSkeleton from './DescriptionSkeleton'
import WidgetDataError from '../../../components/WidgetDataError'
import DescriptionSections from './DescriptionSections'

export default function DescriptionContent() {
  const { options } = useWidget<DescriptionWidgetConfig>()

  const { data, isLoading, isError, error } = useFetchDescription(
    options.filter
  )

  // Above the early returns — hook rules. Was getObjectForCurrentLocale, which
  // resolves at call time from the BROWSER only: a page declaring <html lang>
  // (or a GTranslate widget rewriting it after paint) drove every string that
  // goes through useLocaleDetection but never the description row picked here,
  // so one widget could render an operator string in the page's language over
  // a body in the visitor's (#1535). `detectedLocale` is the same value
  // <DescriptionSections /> resolves, and it re-renders on a `lang` rewrite.
  const { detectedLocale } = useLocaleDetection(
    options.language.useAutoDetectedLocale,
    options.language.locale
  )

  if (isLoading) {
    return <DescriptionSkeleton />
  }

  if (isError) {
    return <WidgetDataError error={error} />
  }

  if (!data?.result?.descriptions || data.result.descriptions.length === 0) {
    return null
  }

  const description = findObjectByLocale(data.result.descriptions, detectedLocale)

  if (!description) {
    return null
  }

  return <DescriptionSections description={description} />
}
